import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CasheringService } from '../../../../domain/services/cashering/cashering.service';
import { ReturnNoteModel } from '../../../../domain/models/return.model';

@Component({
  selector: 'app-return-notes',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatCheckboxModule
  ],
  templateUrl: './return-notes.component.html',
  styleUrls: ['./return-notes.component.css']
})
export class ReturnNotesComponent implements OnInit {
  @Input() returnId!: number;
  @Input() notes: ReturnNoteModel[] = [];

  newNoteContent: string = '';
  maxCharacters: number = 256;

  constructor(private casheringService: CasheringService) {}

  ngOnInit(): void {
    this.loadNotes();
  }

  loadNotes(): void {
    this.casheringService.getNotes(this.returnId).subscribe(
      notes => {
        this.notes = notes;
      },
      error => {
        console.error('Error loading notes:', error);
      }
    );
  }

  getRemainingCharacters(): number {
    return this.maxCharacters - this.newNoteContent.length;
  }

  canPublish(): boolean {
    return this.newNoteContent.trim().length > 0 &&
           this.newNoteContent.length <= this.maxCharacters;
  }

  sendToRegistrant = false;

  publishNote(): void {
    if (!this.canPublish()) return;

    this.casheringService.addNote(this.returnId, this.newNoteContent, undefined, undefined, this.sendToRegistrant).subscribe(
      () => {
        this.newNoteContent = '';
        this.sendToRegistrant = false;
        this.loadNotes();
      },
      error => {
        console.error('Error publishing note:', error);
      }
    );
  }
}
